import { render, staticRenderFns } from "./SplitModal.vue?vue&type=template&id=2e962f94&"
import script from "./SplitModal.vue?vue&type=script&lang=js&"
export * from "./SplitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports